export const SCRIPT_TAG_ESCAPE_REG_EXP = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
